import type * as React from 'react';

import type { NodeProps } from '@xyflow/react';
import type { Node } from '@xyflow/react';

import type { BaseNodeData, NodeDefinition } from '../../types';

import { HttpWebhookTriggerConfig } from './HttpWebhookTriggerConfig';
import {
  HttpWebhookTriggerNode,
  httpWebhookTriggerVisualDefinition,
} from './HttpWebhookTriggerNode';
import {
  HttpWebhookTriggerConfigType,
  defaultHttpWebhookTriggerConfig,
  validateHttpWebhookTriggerConfig,
  getHttpWebhookTriggerPreviewText,
} from './schema';

export { HttpWebhookTriggerNode } from './HttpWebhookTriggerNode';
export { HttpWebhookTriggerConfig } from './HttpWebhookTriggerConfig';
export type { HttpWebhookTriggerConfigType } from './schema';

/** Full definition for the registry */
export const httpWebhookTriggerDefinition: NodeDefinition<HttpWebhookTriggerConfigType> =
  {
    ...httpWebhookTriggerVisualDefinition,
    category: 'trigger',
    NodeComponent: HttpWebhookTriggerNode as unknown as React.ComponentType<
      NodeProps<Node<BaseNodeData>>
    >,
    ConfigComponent: HttpWebhookTriggerConfig,
    defaultConfig: () => ({ ...defaultHttpWebhookTriggerConfig }),
    validateConfig: validateHttpWebhookTriggerConfig,
    getPreviewText: getHttpWebhookTriggerPreviewText,
  };
